import styles from "./University_detail.module.css"
import Header from "../components/layout/header";
import Footer from "../components/layout/footer";
import Breadcrumb from "../components/common/breadcrumb";
import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';

function UniversityDetailPage() {
  const { url } = useParams(); // 👈 lấy :url từ browser
  const [university, setUniversity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [expanded, setExpanded] = useState(false);

  const toggleContent = () => {
    setExpanded(prev => !prev);
  };

  useEffect(() => {
    const fetchUniversity = async () => {
      try {
        const res = await axios.get(
          `https://duhochanquocnewlife.com/api/universities/dai-hoc-han-quoc/${url}`
        );

        setUniversity(res.data.data);
      } catch (err) {
        setError("Không tìm thấy trường đại học");
      } finally {
        setLoading(false);
      }
    };

    fetchUniversity();
  }, [url]);

  const toString = (str) => {
    return str
      .trim()
      .split(/\s+/)     // tách theo khoảng trắng
      .slice(0, -1)     // bỏ phần tử cuối
      .map(word => word.toLowerCase())
      .join('_');
  }

  if (loading) return <p>Đang tải dữ liệu...</p>;
  if (error) return <p>{error}</p>;

  return (
    <>
      <Header />

      <div style={{ backgroundColor: "#f3f5f7" }}>
        <div className='container'>
          <Breadcrumb />

          <div className={styles.uni_detail}>
            <div id={styles.content}>
              {/* Header */}
              <div className={styles.uni_container}>
                <div className={styles.uni_header}>
                  <div className={styles.cover} style={{ backgroundImage: `url(${university.banner})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center center' }}>
                    <img
                      src={`/logos/${toString(university.name_en)}_logo.jpg`}
                      onError={(e) => e.target.src = `/logos/${toString(university.name_en)}_logo.jpg`}
                      alt={`${university.name_vn} - ${university.name_kr}`}
                      className={styles.profile_picture}
                    />
                  </div>

                  <div className={styles.profile_details}>
                    <h1 className={`${styles.profile_name} fw-700`}>
                      {university.name_vn} - {university.name_en}
                    </h1>

                    <div className={styles.links}>
                      {/* Website */}
                      <div className="d-flex gap-2 pt-1 align-c">
                        <img src="/icons/streamline_web.svg" width="20" height="50" alt="Website" />
                        <p className="color-white">
                          {university.website ? (
                            <span>
                              <b>Website: </b><a href={university.website} target="_blank" rel="noreferrer">
                                {university.website}
                              </a>
                            </span>
                          ) : (
                            <span><b>Website:</b> Chưa cập nhật</span>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className={styles.uni_detail}>
                <div className={styles.content_left}>
                  {/* Introduction */}
                  <section className={styles.intro}>
                    <h2 className={`bg-main ${styles.uni_title}`}>Giới thiệu</h2>
                    <div className={styles.intro_body}>
                      <h3 className={`${styles.intro_tit} fw-700`}>{university.name_vn}</h3>

                      <div
                        className={`${styles.intro_content} ws ${expanded ? styles.expanded : ""}`}
                        dangerouslySetInnerHTML={{
                          __html: university.description || "Đang cập nhật..."
                        }}
                      />
                      <div
                        className={`${styles.intro_toggle} d-flex align-c gap-2`}
                        onClick={toggleContent}
                      >
                        <span className="color-main">{expanded ? "Rút gọn" : "Xem thêm"}</span>
                        <img
                          className={`${styles.arrow_icon} ${expanded ? styles.rotated : ""}`}
                          src="/icons/arrow-down.svg"
                          width="12"
                          height="12"
                          alt="toggle icon"
                        />
                      </div>

                      {/* Images */}
                      {/* <h3 className={`${styles.intro_tit} fw-700`}>Hình ảnh về {university.name_vn}</h3>
                      <div className={styles.list_img_cpn}>
                        {
                          university.gallery.map((img, i) => (
                            <img key={i} src={img} className={styles.img_cpn} />
                          ))
                        }
                      </div> */}

                      {/* Admissions */}
                      <h3 className={`${styles.intro_tit} fw-700`}>Thông tin tuyển sinh</h3>

                      <table className={styles.uni_table}>
                        <thead>
                          <tr>
                            <th>Hệ đào tạo</th>
                            <th>Điều kiện</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>Khóa tiếng Hàn</td>
                            <td>{university.admission_requirements.korean_language}</td>
                          </tr>
                          <tr>
                            <td>Đại học</td>
                            <td>{university.admission_requirements.undergraduate}</td>
                          </tr>
                          <tr>
                            <td>Sau đại học</td>
                            <td>{university.admission_requirements.graduate}</td>
                          </tr>
                        </tbody>
                      </table>

                      {/* Majors */}
                      <h3 className={`${styles.intro_tit} fw-700`}>Một số chuyên ngành đào tạo</h3>
                      <ul className={styles.major_list}>
                        {university.programs.majors.map((item, index) => (
                          <li key={index}>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </section>

                  {/* Scholarship */}
                  <div className={`${styles.uni_scholarship} bg-white`}>
                    <h2 className={`bg-main ${styles.uni_title} mb-0`}>
                      Học bổng
                    </h2>
                    <table className={styles.uni_table}>
                      <thead>
                        <tr>
                          <th>Đối tượng và tiêu chuẩn</th>
                          <th>Học bổng</th>
                        </tr>
                      </thead>

                      <tbody>
                        {university.scholarships.map((item, index) => (
                          <tr key={index}>
                            <td>{item.condition}</td>
                            <td>{item.value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Right side */}
                <div className={`${styles.content_right} bg-white`}>
                  <h2 className={`bg-main ${styles.uni_title_right}`}>Thông tin chi tiết</h2>

                  <div className={styles.contact_body}>
                    <div className={styles.top_icon}>
                      <img className={styles.icon_contact} src="/icons/check.svg" alt="Check Icon" />
                      <p className="color-main fw-500">Tên tiếng Hàn</p>
                      <p>{university.name_kr}</p>
                    </div>
                    <div className={styles.top_icon}>
                      <img className={styles.icon_contact} src="/icons/check.svg" alt="Check Icon" />
                      <p className="color-main fw-500">Địa chỉ</p>
                      <p>{university.address}</p>
                    </div>
                    <div className={styles.top_icon}>
                      <img className={styles.icon_contact} src="/icons/check.svg" alt="Check Icon" />
                      <p className="color-main fw-500">Năm thành lập</p>
                      <p>{university.founded_year}</p>
                    </div>
                    <div className={styles.top_icon}>
                      <img className={styles.icon_contact} src="/icons/check.svg" alt="Check Icon" />
                      <p className="color-main fw-500">Loại hình</p>
                      <p>{university.type}</p>
                    </div>
                    <div className={styles.top_icon}>
                      <img className={styles.icon_contact} src="/icons/check.svg" alt="Check Icon" />
                      <p className="color-main fw-500">Số lượng sinh viên</p>
                      <p>{university.total_students} sinh viên, {university.international_students} sinh viên quốc tế</p>
                    </div>
                    <div className={`${styles.top_icon} ${styles.gach_duoi}`}>
                      <img className={styles.icon_contact} src="/icons/check.svg" alt="Check Icon" />
                      <p className="color-main fw-500">Học phí</p>
                      <div>
                        <p><strong>Khóa tiếng Hàn: </strong>{university.tuition.korean_language}</p>
                        <p><strong>Đại học: </strong>{university.tuition.undergraduate_range}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >

      <Footer />
    </>
  );
}

export default UniversityDetailPage;